import React from 'react';
import { useTranslation } from 'react-i18next';
import WebViewAppBar from '../../../components/WebViewAppBar';
import PurchaseSubscriptionPaymentBody from './PurchaseSubscriptionPaymentBody';

import styles from './PurchaseSubscriptionPayment.module.scss';
import { useHistory } from 'react-router-dom';

export default function PurchaseSubscriptionPayment() {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className={styles.paymentContainer}>
      <WebViewAppBar />
      <h1>{t('payment')}</h1>
      <PurchaseSubscriptionPaymentBody includeCancel onSubmit={history.goBack} />
    </div>
  );
}
